/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 * Type enumerates supported payment operation types.
 *
 *  - TYPE_UNSPECIFIED: Default value. Should not be used explicitly.
 *  - TYPE_DEPOSIT: A deposit transaction (funds moving into an account or wallet).
 *  - TYPE_WITHDRAWAL: A withdrawal transaction (funds moving out of an account or wallet).
 *  - TYPE_EXCHANGE: An exchange transaction (converting one asset or currency into another).
 */
export enum UniteTypePaymentType {
    TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
    TYPE_DEPOSIT = 'TYPE_DEPOSIT',
    TYPE_WITHDRAWAL = 'TYPE_WITHDRAWAL',
    TYPE_EXCHANGE = 'TYPE_EXCHANGE',
}
